/* Copyright (c) 2017 Backpack Health LLC */
import * as _ from 'lodash';

import store from '../../redux/reduxStore_authorizedApp';

import actionNames from './actionNames';
import AttachmentsService from '../../../apiServices/AttachmentsService';

import AttachmentModel, { attachmentTypes } from '../../../models/AttachmentModel';

import { getActiveProfileId } from './reduxSelectors';

const selectors = {
  isFetching: state => state.data.attachments.isFetching,
  isSameAs(state, profileId, newData) {
    const collection = state.data.attachments[profileId] ? state.data.attachments[profileId].collection : [];
    return _.isEqual(collection, newData);
  },
};

function requestAttchmentsAction(profileId) {
  return {
    type: actionNames.requestAttachments,
    payload: {
      profileId,
      isFetching: true,
    },
  };
}

export function receiveAllAttachmentsAction(profileId, attachmentCollection) {
  const parentGroups = _.groupBy(attachmentCollection, attachment => attachment.parent.type);
  const attachmentGroups = _.groupBy(attachmentCollection, attachment => attachment.attachment.type);

  _.each(_.keysIn(parentGroups), key => {
    parentGroups[key] = _.groupBy(parentGroups[key], attachment => attachment.parent.id);
  });

  _.each(_.keysIn(attachmentGroups), key => {
    attachmentGroups[key] = _.groupBy(attachmentGroups[key], attachment => attachment.attachment.id);
  });

  return _.assign({}, {
    type: actionNames.receiveAttachments,
    payload: {
      profileId,
      parentGroups,
      attachmentGroups,
      collection: attachmentCollection,
      lastUpdated: new Date().getTime(),
      isFetching: false,
    },
  });
}

function getAll(profileId) {
  return store.dispatch((dispatch, getState) => {
    if (selectors.isFetching(getState())) { return; }

    dispatch(requestAttchmentsAction(profileId));

    AttachmentsService.getAll(
      profileId,
      (apiError, attachmentCollection) => {
        if (apiError) { return; }
        // if (selectors.isSameAs(getState(), profileId, attachmentCollection)) { return; }

        dispatch(receiveAllAttachmentsAction(profileId, attachmentCollection));
      }
    );
  });
}

function deleteAttachment(attachment) {
  const state = store.getState();
  const profileId = getActiveProfileId(state);
  AttachmentsService.del(profileId, attachment.data.id, () => {
    getAll(profileId);
  });
}

function attachNoteToHealthEntry(noteId, healthEntryId, profileId, callback) {
  const attachment = new AttachmentModel();
  attachment.setParent(healthEntryId, attachmentTypes.healthEntry);
  attachment.setAttachment(noteId, attachmentTypes.note);

  AttachmentsService.create(profileId, attachment.data, () => {
    getAll(profileId);
    callback();
  });
}

function attachNoteToHealthEntryValue(noteId, healthEntryValueId, profileId, callback) {
  const attachment = new AttachmentModel();
  attachment.setParent(healthEntryValueId, attachmentTypes.healthEntryValue);
  attachment.setAttachment(noteId, attachmentTypes.note);

  AttachmentsService.create(profileId, attachment.data, () => {
    getAll(profileId);
    callback();
  });
}

function attachFileToHealthEntry(fileId, healthEntryId, profileId, callback) {
  const attachment = new AttachmentModel();
  attachment.setParent(healthEntryId, attachmentTypes.healthEntry);
  attachment.setAttachment(fileId, attachmentTypes.file);

  AttachmentsService.create(profileId, attachment.data, () => {
    getAll(profileId);
    callback();
  });
}

function attachFileToHealthEntryValue(fileId, healthEntryValueId, profileId, callback) {
  const attachment = new AttachmentModel();
  attachment.setParent(healthEntryValueId, attachmentTypes.healthEntryValue);
  attachment.setAttachment(fileId, attachmentTypes.file);

  AttachmentsService.create(profileId, attachment.data, () => {
    getAll(profileId);
    callback();
  });
}

async function attachContactToHealthEntry(contactId, healthEntryId, profileId) {
  const attachment = new AttachmentModel();
  attachment.setParent(healthEntryId, attachmentTypes.healthEntry);
  attachment.setAttachment(contactId, attachmentTypes.contact);

  return AttachmentsService.create(profileId, attachment.data)
    .then(() => {
      getAll(profileId);
    });
}

async function attachContactToHealthEntryValue(contactId, healthEntryValueId, profileId) {
  const attachment = new AttachmentModel();
  attachment.setParent(healthEntryValueId, attachmentTypes.healthEntryValue);
  attachment.setAttachment(contactId, attachmentTypes.contact);

  return AttachmentsService.create(profileId, attachment.data)
    .then(() => {
      getAll(profileId);
    });
}

const AttachmentsActions = {
  getAll,
  deleteAttachment,
  attachNoteToHealthEntry,
  attachNoteToHealthEntryValue,
  attachFileToHealthEntry,
  attachFileToHealthEntryValue,
  attachContactToHealthEntry,
  attachContactToHealthEntryValue,
};

export default AttachmentsActions;
